import React, { Component, Fragment } from "react";
import "./ForgotPassword.scss";
import Logo from "../Logo/index";
import Button from "./Button";
import "./Rectangle.scss";
import { ToastContainer, toast } from "react-toastify";
import Recaptcha from "react-recaptcha";
import LoaderComponent from "src/common/components/loader/loader";
class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEmailFocused: false,
    };
  }
  render() {
    const {
      toggleForgotPassword,
      forgotPassword,
      email,
      handleEmailChange,
      shouldEnableRecaptcha,
      showTag,
      verifyCallback,
      callback,
      onExpire,
      reCaptchaKey
    } = this.props;
    return (
      <Fragment>
        {/* <Rectangle className={"otpRectangleTopL"} /> */}
        {/* <Rectangle className={"otpRectangleTopS"} /> */}
        <div className="forgotPasswordFormCardMain">
          <ToastContainer />
          <div className="forgotPasswordFormCard">
            <div className="forgotPasswordFormLogo">
              <Logo className="forgotPasswordLogoImage" />
            </div>
            <div className="forgotPasswordFormEmailMain">
              <p className="forgotPasswordFormEmailLable">Email</p>
              <div className={`forgotPasswordFormEmailBox ${this.state.isEmailFocused ? 'box-focused' : ''}`}>
                <input
                  type="text"
                  name="email"
                  className="forgotPasswordFormEmailInput"
                  value={email}
                  onChange={handleEmailChange}
                  onFocus={() => this.setState({ isEmailFocused: true })}
                  onBlur={() => this.setState({ isEmailFocused: false })}
                >

                </input>
              </div>
            </div>

            {shouldEnableRecaptcha() &&
              <div className="recaptcha-container">
                {
                  showTag &&
                <Recaptcha
                  sitekey="6LcHtbwUAAAAAKkjbo7nNh9ajzF5GEHk9uC5skGG"
                  render="explicit"
                  verifyCallback={verifyCallback}
                  onloadCallback={callback}
                  expiredCallback={onExpire}
                  key={reCaptchaKey}
                />
                }
              </div>
            }

            <div className="forgotPasswordButtonBox">
              <Button
                Name={"Submit"}
                className={"forgotPasswordButton"}
                onClick={forgotPassword}
                value={"Submit"}
              />
            </div>
            <div className="forgotPasswordBackToSignInLableBox">
              <p
                className="forgotPasswordBackToSignInLable"
                onClick={toggleForgotPassword}
              >
                Back To SignIn
              </p>
            </div>
          </div>
        </div>
        {/* <Rectangle className={"otpRectangleBottomL"} /> */}
        {/* <Rectangle className={"otpRectangleBottomS"} /> */}
      </Fragment>
    );
  }
}
export default ForgotPassword;
